import gql from 'graphql-tag';

export default gql `
  mutation resetPassword($email: String!) {
    resetPassword(email: $email) {
      email
    }
  }
`;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/apollo/graphql/FORGOT.js
 **/